<main class="container">
    <div id="containerLeftMenu" style="margin-right: 15px">  
        <left-menu [showImportExport]="false"/>
     </div> 
    <section id="column2">
        <div class="row">
            <div class="col col-12">
                <h2>Chevron Fitness-for-Service Level 1 Application (FFS Level 1)
                </h2>
                <div>
                    <p>The construction codes (e.g., ASME Pressure Vessel Code) for pressurized equipment provide rules for the design, fabrication, and testing of new
equipment, but do not address in-service degradation and deficiencies found in the equipment during in-service inspections. Fitness-for-Service
(FFS) assessments are quantitative engineering evaluations which are used to demonstrate the structural integrity of an in-service equipment
containing deficiency / deficiencies. </p> <br />

<p>Chevron FFS (Fitness-for-Service) Level 1 is a screening tool that include assessment procedures that can be used to evaluate in-service
pressurized components containing flaws or damage. If the results of an FFS Assessment indicate that the equipment is suitable for the current
operating conditions, then the equipment can continue to be operated provided suitable monitoring/inspection programs are established. The
program follows the International Code API 579-1/ASME FFS-1, December 2021 Level 1 procedures. </p> <br />

                    
                </div>
            </div>
        </div>
    </section>
</main>